import { render, staticRenderFns } from "./bank.vue?vue&type=template&id=28d02837&scoped=true"
import script from "./bank.vue?vue&type=script&lang=js"
export * from "./bank.vue?vue&type=script&lang=js"
import style0 from "./bank.vue?vue&type=style&index=0&id=28d02837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d02837",
  null
  
)

export default component.exports